/* eslint-disable import/no-unused-modules */
// TODO: [JIRA-XXXX] remove in next PR
import SearchControls, { LAYOUT } from './SearchControls';

export default SearchControls;
export { LAYOUT };
